import { render, staticRenderFns } from "./address_edit_dialog.vue?vue&type=template&id=66cfac20&scoped=true"
import script from "./address_edit_dialog.vue?vue&type=script&lang=js"
export * from "./address_edit_dialog.vue?vue&type=script&lang=js"
import style0 from "./address_edit_dialog.vue?vue&type=style&index=0&id=66cfac20&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66cfac20",
  null
  
)

export default component.exports